import React from "react";
import "../../Styles/about.css";
import computer from "../../Assets/desktop_computer-bro.png";

export default function AboutCompany() {
  return (
    <div className="about">
      <div className="aboutContainer">
        <div className="left">
          <div className="name">SUPIX</div>
          <div className="dis">
            <div>Supix Private Limited (SPL) is a Private Limited</div>
            <div> Indian Non-Government Company</div>
            <div> incorporated in India on 28 December 2021</div>
            <div>(One year and five months old). </div>
            <div>
              Supix computer technology company focusing on artificial
              intelligence,
            </div>
            <div> Blockchain technology, crypto currency, nft, metaverse, </div>
            <div>
              search engine technology, cloud computing, computer software
            </div>
            <div>quantum computing, e-commerce, and consumer electronics.</div>
          </div>
        </div>
        <div className="right">
          <img src={computer} alt="" />
        </div>
      </div>
      {/* <div className="dots">
        <div className="dots"></div>
        <div className="dots"></div>
        <div className="dots"></div>
      </div> */}
    </div>
  );
}
